import script from "./MAcordeaoImportadores.vue?vue&type=script&setup=true&lang=ts"
export * from "./MAcordeaoImportadores.vue?vue&type=script&setup=true&lang=ts"

import "./MAcordeaoImportadores.vue?vue&type=style&index=0&id=65eb2993&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65eb2993"]])

export default __exports__